import Swal from 'sweetalert2';
import clienteAxios from '../../helper/axios';
import { bienestar, informesDone, limpiarInformeAEditar } from './contadorBienestarSlice';

export const startcontadorBienestar = () => async (dispatch) => {
  try {
    const { data } = await clienteAxios.get('/admin/tiles-bienestar', {
      headers: {
        'Content-Type': 'application/json',
        'x-token': localStorage.getItem('token') || '',
      },
    });

    dispatch(bienestar(data.contador));
  } catch (error) {
    console.error(error);
  }
};

export const generarInforme = (id, info) => async (dispatch) => {
  try {
    const respuesta = await clienteAxios.patch(
      `/admin/informe-bienestar/${id}`,
      { info },
      {
        headers: {
          'Content-Type': 'application/json',
          'x-token': localStorage.getItem('token') || '',
        },
      }
    );
    Swal.fire(respuesta.data.mensaje, 'Informe generado correctamente.', respuesta.data.success);
    dispatch(startcontadorBienestar());
    dispatch(limpiarInformeAEditar());
  } catch (error) {
    console.error('-->', error);
  }
};

export const eliminarInformeBienestar = (id) => async (dispatch) => {
  try {
    // Mostrar confirmación antes de eliminar
    const confirmacion = await Swal.fire({
      title: '¿Está seguro de cancelar esta petición?',
      text: "Esta acción no se puede revertir",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí, cancelar',
      cancelButtonText: 'No, mantener'
    });

    if (confirmacion.isConfirmed) {
      const respuesta = await clienteAxios.delete(
        `/admin/informe-bienestar/${id}`,
        {
          headers: {
            'Content-Type': 'application/json',
            'x-token': localStorage.getItem('token') || '',
          },
        }
      );
      
      Swal.fire(
        'Cancelada',
        'La petición ha sido cancelada correctamente.',
        'success'
      );
      
      // Actualizar la lista de informes
      dispatch(startcontadorBienestar());
    }
  } catch (error) {
    console.error('Error al eliminar informe:', error);
    Swal.fire(
      'Error',
      'No se pudo cancelar la petición. Por favor, intente nuevamente.',
      'error'
    );
  }
};

export const startInformesDone = () => async (dispatch) => {
  try {
    const { data } = await clienteAxios.get('/admin/informe-bienestar-realizados', {
      headers: {
        'Content-Type': 'application/json',
        'x-token': localStorage.getItem('token') || '',
      },
    });

    dispatch(informesDone(data.contador));
  } catch (error) {
    console.error(error);
  }
};
